import React from "react";
import Address from "../../components/Checkout/Address";
import Payment from "../../components/Checkout/Payment";
import ReviewOrder from "../../components/Checkout/ReviewOrder";
import ScreenSteps from "../../components/UI/ScreenSteps/ScreenSteps";
import Logo from "../../assets/images/logo.png"
const Checkout  = ()=>{
    return(
        <div className="container-fluid" >
            <div className="mt-3" style={{position:"relative",left:"9%"}}>
                <img src={Logo} width="100px" height="80px" />
                
            </div>
            <hr/>
            <ScreenSteps>
                <Address/> 
                <Payment/>
                <ReviewOrder/>
            </ScreenSteps>
        </div>
    )
}

export default Checkout;